import { Injectable } from '@angular/core';
import { TenantService } from '@segurosvoluntarios_vel/commons-services';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TenantManagerService {
  tenant$: Observable<string>;

  constructor(private tenantService: TenantService) {
    this.subscribeToTenant();
  }

  subscribeToTenant() {
    this.tenant$ = this.tenantService
      .getTenant()
      .pipe(filter((tenant: string) => !!tenant));
  }

  get tenant(): Observable<string> {
    return this.tenant$;
  }
}
